module.exports = __webpack_public_path__ + "static/media/new_fund.4a6411f1.svg";